<template>
	<client-only>
		<div class="swiper-outside-container">
			<swiper
				ref="swiper"
				class="swiper pb-12"
				:options="swiperOption"
			>
				<swiper-slide
					v-for="(agent, n) in (agentList && agentList.length > 0 ? agentList : 12)"
					:ref="`slide${n}`"
					:key="n"
					v-resize="onResize"
				>
					<agentListItem
						v-if="agentList && agentList.length > 0"
						:agent="agent"
					/>
					<agentListItemSkeleton v-else />
				</swiper-slide>
				<div
					slot="pagination"
					class="swiper-pagination py-2"
					:class="{'bullets-white': white}"
				/>
			</swiper>
			<v-btn
				color="white"
				min-width="52"
				elevation="10"
				class="d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="swipePrev"
			>
				<v-icon class="red--text">
					mdi-chevron-left
				</v-icon>
			</v-btn>
			<v-btn
				color="red"
				min-width="52"
				elevation="10"
				class="d-none d-md-flex px-0"
				absolute
				tile
				x-large
				@click="swipeNext"
			>
				<v-icon class="white--text">
					mdi-chevron-right
				</v-icon>
			</v-btn>
		</div>
	</client-only>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

import agentListItemSkeleton from '~/components/2.0/agent-list-item-skeleton'
import agentListItem from '~/components/2.0/agent-list-item'

export default {
	components: {
		agentListItemSkeleton,
		agentListItem,
		Swiper,
		SwiperSlide
	},

	props: {
		white: {
			type: Boolean,
			default: false
		},
		count: {
			type: Number,
			default: 4
		},
		items: {
			type: Array,
			default: () => []
		}
	},

	data:() => ({
		model: null,
		property: null,
		maxHeight: '100%',

		queryList: null
	}),

	computed: {
		swiperOption () {
			let items = 1.2
			/*
			if (this.$vuetify.breakpoint.sm) {
				items = 2.2
			}
			if (this.$vuetify.breakpoint.md) {
				items = 3.5
			}
			if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				items = 4
			}
			*/

			if (this.$vuetify.breakpoint.sm) {
				items = 2.2
			}
			if (process.client && window.innerWidth > 750) {
				items = 3.2
			}
			if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
				items = 4
			}

			return {
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicBullets: true,
					dynamicMainBullets: 3
				},
				centeredSlides: items !== 4,
				centeredSlidesBounds: true,
				// grabCursor: true,
				slidesPerView: items,
				slidesPerGroup: 1,
				spaceBetween: 15,
			}
		},

		agentList () {
			return this.items || null
		}
	},

	created() {

	},

	methods: {
		onResize () {
			this.$nextTick(() => {
				this.maxHeight = this.$refs['slide1'][0].$el.clientWidth * 0.75
			})
		},

		swipePrev () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slidePrev()
			}
		},
		swipeNext () {
			if (this.$refs.swiper.$swiper) {
				this.$refs.swiper.$swiper.slideNext()
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.swiper-outside-container {
	position: relative;

	& > .v-btn--absolute {
		top: 50%;
    right: -52px;
    left: unset;

		&:first-of-type {
			margin-top: -68.5px;
		}
		&:last-of-type {
			margin-top: -16.5px;
		}
	}

	.swiper-pagination::v-deep {
		.swiper-pagination-bullet {
			background-color: #ed1c24;

			&.swiper-pagination-bullet-active::before {
				content: ' ';
				position: absolute;
				top: -2px;
				left: -2px;
				width: 12px;
				height: 12px;
				border: solid 1px #ed1c24;
				border-radius: 50%;
			}
		}

		&.bullets-white {
			.swiper-pagination-bullet {
				background-color: #fff !important;

				&.swiper-pagination-bullet-active::before {
					border-color: #fff !important;
				}
			}
		}
	}

	& ::v-deep .swiper-wrapper {
		height: unset !important;
	}
	& .swiper-slide {
		height: unset !important;
	}
}
</style>
